<template>
  <div class="mb-4">

    <!--#region -- Content ---->
    <!--#region ES Basic Info-->
    <div>
      <div v-if="sf_es_info">
        <div style="font-size: 15.5px;font-weight: bold;margin-top: 18px;">
          Basic Information
        </div>
        <!-- <b-badge style="margin-right: 10px;" v-if="sf_es_info" variant="primary">{{sfdcProducts.length}}</b-badge>-->
      </div>
      <div style="padding-top: 10px;" v-if="sf_es_info">
        <div class="row mb-4">
          <div class="col-4">
            <div class="header-col">
              <div>ES ID <span v-if="accessEsDetailPermission()">(click for details)</span></div>
              <div v-if="accessEsDetailPermission() && es_main_info_obj !== null && _.get(es_main_info_obj, 'opty_obj_id', null) != null">
                <a class="link"
                   target="_blank"
                   :href="safeUrl(`${ frontEndUrlToUse }engineering-service/opty-id/${ _.get(es_main_info_obj, 'opty_obj_id', null) }`)">
                  {{ _.get(es_main_info_obj, 'es_id', null) }}
                </a>
              </div>
              <div v-else>
                {{ _.get(es_main_info_obj, 'opty_obj_id', '')}}
              </div>
            </div>
            <div class="header-col">
              <div>Customer</div>
              <div>{{ _.get(es_main_info_obj, 'account_name', '')}}</div>
            </div>
            <div class="header-col">
              <div>Opportunity</div>
              <gtc-opportunity v-if="es_main_info_obj != null && _.get(es_main_info_obj, 'opty_master_id', null) != null"
                               :opportunityId="_.get(es_main_info_obj, 'opty_master_id', null)"
                               :opportunityName="_.get(es_main_info_obj, 'opty_name', '')" />
            </div>
          </div>
          <div class="col-4">
            <div class="header-col">
              <div>ES Purpose</div>
              <div v-if="_.get(es_main_info_obj, 'primary_info', null)!== null">
                {{ _.get(es_main_info_obj, 'primary_info.es_purpose', '') }}
              </div>
            </div>
            <div class="header-col">
              <div>Mapping Issue</div>
              <div v-if="_.get(es_main_info_obj, 'primary_info', null)!== null">
                {{ _.get(es_main_info_obj, 'primary_info.matching_issue', '') }}
              </div>
            </div>
            <div class="header-col">
              <div>
                Requirement stage
              </div>
              <div v-if="_.get(es_main_info_obj, 'primary_info', null)!== null">
                {{ _.get(es_main_info_obj, 'primary_info.requirement_stage', '') }}
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="header-col">
              <div>Source (SFDC)</div>
              <div>
                {{ _.get(es_main_info_obj, 'request_type', '')  }}
              </div>
            </div>
            <div class="header-col">
              <div>Request Type (SFDC)</div>
              <div>{{ _.get(es_main_info_obj, 'issue_type', '') }}</div>
            </div>
            <div class="header-col">
              <div>Issue Type (SFDC)</div>
              <div>{{ _.get(es_main_info_obj, 'source', '') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--#endregion-->
    <!--#region ES Tech Info-->
    <div>
      <div v-if="sf_es_info">
        <div style="font-size: 15.5px;font-weight: bold;margin-top: 18px;">
          Technical Information
        </div>
      </div>
      <div style="padding-top: 10px;" v-if="sf_es_info">
        <div class="row mb-4">
          <div class="col-4">
            <div class="header-col">
              <div>Model</div>
              <div v-if="_.get(es_main_info_obj, 'tech_info', null)!== null">
                {{ _.get(es_main_info_obj, 'tech_info.model', '')  }}
              </div>
            </div>
            <div class="header-col">
              <div>Priority</div>
              <div v-if="_.get(es_main_info_obj, 'tech_info', null)!== null">{{ _.get(es_main_info_obj, 'tech_info.priority', '') }}</div>
            </div>
            <div class="header-col">
              <div>Due Date</div>
              <div v-if="_.get(es_main_info_obj, 'tech_info', null)!== null">{{ _.get(es_main_info_obj, 'tech_info.due_date', '') }}</div>
            </div>
            <div class="header-col">
              <div>3rd-Party Applications</div>
              <div>{{ _.get(sf_es_info, 'X3RD_PARTY_APPLICATIONS__C', '') }}</div>
            </div>
          </div>
          <div class="col-8">
            <div class="header-col">
              <div>ES Issue/Requirement</div>
              <div v-if="_.get(es_main_info_obj, 'tech_info', null)!== null">{{ _.get(es_main_info_obj, 'tech_info.es_issue', '') }}</div>
            </div>

            <div class="header-col">
              <div>Configuration</div>
              <div>{{ _.get(sf_es_info, 'PRESALES_CONFIGURATION__C', '')  }}</div>
            </div>
            <div class="header-col">
              <div>Detailed Spec</div>
              <div>{{ _.get(sf_es_info, 'PRESALES_SPEC__C', '') }}</div>
            </div>
            <div class="header-col">
              <div>User Scenario</div>
              <div v-if="_.get(es_main_info_obj, 'tech_info', null)!== null">
                {{ _.get(es_main_info_obj, 'tech_info.user_scenario', '') }}
                <!-- <div>{{ _.get(sf_es_info, 'CUSTOMER_APPLICATION__C', '')}}</div> -->
              </div>
            </div>
            <!--
                      <div class="header-col">
                          <div>Impact</div>
                          <div v-if="_.get(es_main_info_obj, 'tech_info', null)!== null">{{ _.get(es_main_info_obj, 'tech_info.impact', '') }}</div>
                        </div>
            -->
          </div>

        </div>
      </div>
    </div>
    <!--#endregion-->
    <!--#region Customization Info-->
    <div>
      <div v-if="sf_es_info && es_main_info_obj">
        <div style="font-size: 15.5px;font-weight: bold;margin-top: 18px;">
          Additional Information for Customization
        </div>
      </div>
      <div style="padding-top: 10px;" v-if="sf_es_info && es_main_info_obj">
        <div class="row mb-4">
          <div class="col-4">
            <div class="header-col">
              <div>Delivery Date of POC</div>
              <div>{{ _.get(sf_es_info, 'DELIVERY_DATE_OF_MP__C', '') | dateTimeFormat}} </div>
            </div>
            <div class="header-col">
              <div>Delivery Date of MP</div>
              <div>{{ _.get(sf_es_info, 'DELIVERY_DATE_OF_POC__C', '') | dateTimeFormat}}</div>
            </div>

          </div>

          <div class="col-8">
            <div class="header-col">
              <div>Customization Request</div>
              <div v-if="_.get(es_main_info_obj, 'customization_info', null)!== null">
                {{ _.get(es_main_info_obj, 'customization_info.customization_request', '') }}
              </div>
            </div>
            <div class="header-col">
              <div>ECO System</div>
              <div>{{ _.get(sf_es_info, 'ECO_SYSTEM__C', '') }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="header-col">
              <div style="font-weight:bold">Autopilot Related</div>
              <div class="row">
                <div class="col">

                  <div class="row">
                    <div class="col">
                      <div>
                        <span>Has Autopilot Request :</span>
                      </div>

                      <b-form-radio-group id="autopilot-radio-1"
                                          v-model="es_main_info_obj.sa_selected_autopilot"
                                          :options="autopilotOptions"
                                          name="autopilot-radio"
                                          disabled>
                        <b-form-invalid-feedback :state="!autopilotState">* Expand below to view Autopilot Info</b-form-invalid-feedback>
                      </b-form-radio-group>
                    </div>
                  </div>

                  <div class="row" v-if="_.get(es_main_info_obj, 'autopilot_info', null)!== null">
                    <div class="accordion" role="tablist">
                      <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button block v-b-toggle.accordion-3
                                    variant="'secondary'"
                                    class="'text-dark'"
                                    style="text-align: left;">
                            <b>
                              <img src="../../../static/image/getac-icon-dash-dark.svg"
                                   style="height: 0.8rem;width: 1rem;margin-right: 0.25rem;" alt="Getac Dashboard Dark Icon"/>
                              Autopilot Required Info (Tenant ID, Domain Name, Intune Admin Email)
                            </b>
                          </b-button>
                        </b-card-header>
                        <b-collapse id="accordion-3" accordion="customization-info" role="tabpanel">
                          <b-card-body>
                            <div>
                              <div class="row" style="margin-top:10px">
                                <div class="col">
                                  <div>
                                    Tenant ID :
                                  </div>
                                  <div v-if="_.get(es_main_info_obj, 'autopilot_info', null)!== null" style="font-style:italic">
                                    {{ _.get(es_main_info_obj, 'autopilot_info.tenant_id', null) }}
                                  </div>
                                </div>
                                <div class="col">
                                  <div>
                                    Domain Name :
                                  </div>
                                  <div v-if="_.get(es_main_info_obj, 'autopilot_info', null)!== null" style="font-style:italic">
                                    {{ _.get(es_main_info_obj, 'autopilot_info.tenant_domain', null) }}
                                  </div>
                                </div>
                              </div>
                              <div class="row" style="margin-top:10px">
                                <div class="col">
                                  <div>
                                    Admin Email :
                                  </div>
                                  <div v-if="_.get(es_main_info_obj, 'autopilot_info', null)!== null" style="font-style:italic">
                                    {{ _.get(es_main_info_obj, 'autopilot_info.admin_email_val', null) }}
                                  </div>
                                </div>
                                <div class="col">
                                  <div>
                                    Group Tag:
                                    <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                                            v-b-tooltip.hover.bottom
                                            title="Optional. If left blank, the group tag will not be set for customer."></button>

                                  </div>
                                  <div v-if="_.get(es_main_info_obj, 'autopilot_info', null)!== null" style="font-style:italic">
                                    {{ _.get(es_main_info_obj, 'autopilot_info.group_val', null) }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div>
                        <span>
                          <div class="d-flex pb-1">
                            <b-button v-if="es_main_info_obj.sa_selected_autopilot=== 'Yes'" @click="checkCustomeConsent" class="btn btn-primary btn-sm min-w-4" variant="primary">Check</b-button>
                            <div class="mt-1">About Customer Consent : </div>
                            <span v-if="consentStatusDisplay && es_main_info_obj.sa_selected_autopilot=== 'Yes'" class="mt-1 pl-2">Consent status <b-icon v-if="isConsent" icon="check-circle-fill" variant="success"></b-icon> <b-icon v-else icon="x-circle-fill" variant="danger"></b-icon></span>
                          </div>
                          <div class="alert alert-danger alert-dismissible" role="alert">
                            <strong>Attention!</strong>
                            The old consent link has been expired by Microsoft (MSFT passively notified us on 28th Feb 2024). Here is the new consent link we should provide to our customer for Autopilot Consent:
                            <a href="https://admin.microsoft.com/Adminportal/Home?invType=OEM&partnerId=01c3a8ab-27fa-4d9c-8e50-f69ccf103a13#/partners/invitation" target="_blank">https://admin.microsoft.com/Adminportal/Home?invType=OEM&partnerId=01c3a8ab-27fa-4d9c-8e50-f69ccf103a13#/partners/invitation</a>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            </button>
                          </div>
                          <span class="text-primary pl-1"> Consent need to be accepted by the customer to authorize Getac as partner within the customer’s environment.</span>
                          <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                                  @click="showAutopilotInfoModal()"
                                  v-b-tooltip.hover.bottom
                                  title="Click for more info"></button>
                          <b-modal ref="ConsentDetailModal"
                                   centered size="lg" :title="'About Customer Consent'" button-size="sm" hide-footer>
                            <div class="d-block">
                              <div v-html="safeHtml(autopilot_consent_text)"></div>
                            </div>
                          </b-modal>

                        </span>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--#endregion-->
    <!--#region SectorSolution Info-->
    <div>
      <div style="margin-top: 18px;"
           v-if="es_main_info_obj !== null && _.get(es_main_info_obj, 'sector_solution_info', null) !== null">
        <div class="row">
          <div class="col">
            <div>
              <span style="font-size: 15.5px;font-weight: bold;">
                Additional Information for Sector Solution
              </span>
              <span style="margin-left:10px" v-if="accessEsDetailPermission()">
                <a v-if="es_main_info_obj !== null && _.get(es_main_info_obj, 'opty_obj_id', null) != null"
                   class="link"
                   target="_blank"
                   :href="safeUrl(`${ frontEndUrlToUse }engineering-service/opty-id/${ _.get(es_main_info_obj, 'opty_obj_id', null) }`)">
                  click to view more or update info
                </a>
              </span>
            </div>
          </div>

        </div>
        <!-- <b-badge style="margin-right: 10px;" v-if="sf_es_info" variant="primary">{{sfdcProducts.length}}</b-badge>-->
      </div>
      <!--- es_main_info_obj.sector_solution_info.environment  -->
      <div style="padding-top: 10px;" v-if="es_main_info_obj">
        <div class="row mb-4">
          <div class="col-4">
            <div class="header-col">
              <div>Environment</div>
              <div>{{ _.get(es_main_info_obj, 'sector_solution_info.environment', '') }} </div>
            </div>
            <div class="header-col">
              <div>Scenario</div>
              <div>{{ _.get(es_main_info_obj, 'sector_solution_info.scenario', '')}}</div>
            </div>
            <div class="header-col">
              <div>Behavior</div>
              <div>{{ _.get(es_main_info_obj, 'sector_solution_info.behavior', '')}}</div>
            </div>
          </div>
          <div class="col-4">
            <div class="header-col">
              <div>Pain Point</div>
              <div>{{ _.get(es_main_info_obj, 'sector_solution_info.pain_point', '') }}</div>
            </div>
            <div class="header-col">
              <div>User Need</div>
              <div>{{ _.get(es_main_info_obj, 'sector_solution_info.user_need', '') }}</div>
            </div>
            <div class="header-col">
              <div>Imaging Process</div>
              <div>{{ _.get(es_main_info_obj, 'sector_solution_info.imaging_process', '') }}</div>
            </div>
          </div>
          <div class="col-4">
            <div class="header-col">
              <div>Installation Process</div>
              <div>{{ _.get(es_main_info_obj, 'sector_solution_info.installation_process', '')  }}</div>
            </div>
            <div class="header-col">
              <div>Deployment Plan</div>
              <div>{{ _.get(es_main_info_obj, 'sector_solution_info.deployment_plan', '') }}</div>
            </div>
            <div class="header-col">
              <div>User Workflow</div>
              <div>{{ _.get(es_main_info_obj, 'sector_solution_info.user_workflow', '') }}</div>
            </div>
            <div class="header-col">
              <div>Work Details</div>
              <div>{{ _.get(es_main_info_obj, 'sector_solution_info.work_details', '') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--#endregion-->
  </div>
</template>

<script>
  import { safeUrl } from '@/helpers/vue-url';
  import { safeHtml } from '@/helpers/vue-safehtml';
  export default {
    name: 'es-info-tab',
    props: {
      prop_es_main_info_obj: {
        default: null
      },
      prop_es_info_obj: {
        default: null
      },
      prop_sf_opty_info_obj: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },
      prop_basic_info: {
        default: null
      },
      prop_site: {
        default: null
      }
    },
    data: function () {
      return {
        isRouterAlive: true,
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        es_main_info_obj: null,
        sf_es_info: null,
        sf_opty_info: null,
        fixModel: true,
        basicInfo: null,
        loginUser: null,
        userSites: null,
        actionEnable: false,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        ftieId: encodeURIComponent(this.$route.params.ftie_id),
        createBy: null,
        realSkuNo: null,
        searching: false,
        isConsent: false,
        consentStatusDisplay: false,
        maintianPnHint: '* Please maintain PN first!',
        noneSelectedHint: 'None Selected',
        updateErrMsg: null,
        selectedMpsIdToSync: [],
        reloadBusy: false,
        processedIndex: [],
        autopilotOptions: [{ text: 'No', value: 'No' }, { text: 'Yes', value: 'Yes' }],

        autopilot_consent_text: ` <ul>
<h5>Microsoft requires customer consent before allowing Getac to register devices for Autopilot.</h5>

<li>If customer have not provided consent, please provide link below and guide them to complete this step.
<br/>
<span style="font-weight:bold; color: red">[New Consent Link Updated by Microsoft Since 2024 Feb] </span>
<a href="https://admin.microsoft.com/Adminportal/Home?invType=OEM&partnerId=01c3a8ab-27fa-4d9c-8e50-f69ccf103a13#/partners/invitation">
         https://admin.microsoft.com/Adminportal/Home?invType=OEM&partnerId=01c3a8ab-27fa-4d9c-8e50-f69ccf103a13#/partners/invitation </a>

<br/><b>(THIS LINK WILL ONLY WORK FOR AZURE GLOBAL ADMINISTRATORS. IT WILL BE BROKEN FOR EVERYONE ELSE)</b>
  </li>
<li>Here is a Microsoft Article that shows the process.
If your customer has never performed this process before, this link will be an excellent guide<br/>
<a href="https://docs.microsoft.com/en-us/mem/autopilot/registration-auth">https://docs.microsoft.com/en-us/mem/autopilot/registration-auth</a>
</li>
<li>If your customer does not know how to get their Tenant ID, Name, or Admin Email,
please send them the following:<br/>
<a href="https://learn.microsoft.com/en-us/azure/active-directory/fundamentals/how-to-find-tenant">https://learn.microsoft.com/en-us/azure/active-directory/fundamentals/how-to-find-tenant</a>
</li>
</ul>`,
      }
    },
    computed: {
      autopilotState() {
        let self = this;
        return Boolean(self.es_main_info_obj && self.es_main_info_obj.sa_selected_autopilot == 'Yes');
      },
      userFunctions() {
        return this.$session.get('user_functions');
      },
      userRoles() {
        return this.$session.get('user_roles');
      }
    },
    created() {
      let self = this;
      self.es_main_info_obj = self.prop_es_main_info_obj;
      self.sf_es_info = self.prop_es_info_obj;
      self.sf_opty_info = self.prop_sf_opty_info_obj;
      self.basicInfo = self.prop_basic_info;
      self.ticketSite = self.prop_site;
      self.createBy = _.get(self.basicInfo, 'gtc_owner', null);
      self.userSites = self.prop_user_sites;
      self.loginUser = self.prop_user;
      self.actionEnable = self.checkActionEnable();
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      showAutopilotInfoModal() {
        this.$refs['ConsentDetailModal'].show()
      },
      accessEsDetailPermission() {
        let self = this;
        if (self.es_main_info_obj === null || self.loginUser === null) {
          return false;
        } else {
          if ((_.get(self.es_main_info_obj, 'es_ticket_create_by', null) !== null) &&
            (self.loginUser === _.get(self.es_main_info_obj, 'es_ticket_create_by', null) || self.loginUser === _.get(self.es_main_info_obj, 'gtc_owner', null)//gtc owner
              || (self.userRoles && _.indexOf(self.userRoles, 'Admin') > -1) || (self.userFunctions && _.indexOf(self.userFunctions, 'ES PM Leader') > -1)
              || (self.userRoles && _.indexOf(self.userRoles, 'ES_PM_Leader') > -1)
              || (self.userFunctions && _.indexOf(self.userFunctions, 'Tech Leader') > -1)
              || (self.userRoles && _.indexOf(self.userRoles, 'ASSIGNER') > -1)
            )
          ) {
            return true
          }
          else {
            if (self.userSites !== null && self.userSites.includes(self.ticketSite)
              &&
              (self.loginUser === _.get(self.es_main_info_obj, 'es_ticket_create_by', null)
              || self.userRoles !== null && _.indexOf(self.userRoles, 'GRO_SA_MANAGER') > -1)
            ) {
              return true;
            }
            return false
          }
        }
      },

      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        // loginUser is gtc owner
        if (self.loginUser !== null && self.createBy !== null && self.loginUser === self.createBy) {
          return true;
        }
        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1) {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
            return true;
          }
        }
        return false;
      },
      checkCustomeConsent() {
        let self = this;
        let resultText = null;
        let url = self.$root.baseUrl + '/engineering-service/check-customer-consent/';
        let request_data = {
          tenant_id: _.get(self.es_main_info_obj, 'autopilot_info.tenant_id', null),
          tenant_domain: _.get(self.es_main_info_obj, 'autopilot_info.tenant_domain', null),
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            if (response.status === 200) {
              var isConsent = res['isConsent']
              self.consentStatusDisplay = true;
              self.isConsent = isConsent;
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });

      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework/EsInfoTab.vue